module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true,
      "lock-hide-in-preview": true
    }
  }, _vm.$listeners), [(_vm.item.type === 'shared-form-preview') ? _c('form-builder-shared-form-preview', {
    attrs: {
      "loading": false,
      "field-data": _vm.item,
      "form-id": _vm.id
    },
    on: {
      "update": function($event) {
        _vm.item = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce154aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorSharedFormPreview.vue
// module id = 1709
// module chunks = 1